// Source discrepancies remain review items; matching a contact does not clear amount discrepancies.
export function invoiceIssues(document) {
 const d=document.data;
 if(d.source!=='xero')return [];
 return (d.source_issues||[]).flatMap(message=>{
  if(message.startsWith('Orijinal faturada müşteri adresi'))return d.bill_address?.trim()?[]:[{title:'Fatura adresi eksik',message:'Orijinal faturada alıcının adresi yok. Doğru adresi kontrol edip CRM eşleşmesinden ekleyebilirsin.'}];
  if(message.startsWith('Fatura alıcısı ile CRM'))return d.customer_id?[]:[{title:'Proje irtibatı eşleşmedi',message:'Bu faturaya bağlı CRM irtibatı henüz seçilmedi. Fatura alıcısı ile proje irtibatı farklı olabilir.'}];
  // A standalone invoice is supported and is not itself an error.
  if(message.startsWith('Kaynakta proje kodu yok'))return [];
  return [{title:message.includes('iki fatura')?'İki faturanın ilişkisi kontrol edilmeli':message.includes('tutar')||message.includes('fark')?'Tutar farkı kontrol edilmeli':'Eski kayıt bağlantısı kontrol edilmeli',message}];
 });
}
